<template>
  <div class="config">
   <a
      href="https://slack.com/oauth/authorize?scope=incoming-webhook,commands,bot&client_id=365227780516.366503185463">
        <img alt="Add to Slack" height="40" width="139" src="https://platform.slack-edge.com/img/add_to_slack.png" srcset="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x" />
    </a>
  </div>
</template>

<script>

export default {
  name: 'Configure',
  data: function () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Configure.vue